import { useComposableIcons } from './useComposableIcons';

type ComposableIconsProps = {
  iconConfig: string[];
};

export const ComposableIcon = ({ iconConfig }: ComposableIconsProps) => {
  const sheetConfig = useComposableIcons();

  return (
    <div
      className="composableIcon"
      style={{
        position: 'relative',
        width: sheetConfig.spriteSize,
        height: sheetConfig.spriteSize,
        margin: 'var(--space-xs, 4px)',
      }}
    >
      {iconConfig.map((iconId) => {
        const idParams = iconId.split('_');

        const id = idParams[idParams.length - 1];
        if (!sheetConfig.mapping[id]) {
          console.error('No icon for ' + iconId);
          return <></>;
        }

        // Checking for icon variation flags
        const scale = idParams.includes('s') ? 0.6 : 1;
        const scaleX = idParams.includes('h') ? -scale : scale;
        const scaleY = idParams.includes('v') ? -scale : scale;
        const opacity = idParams.includes('o') ? 0.35 : 1;
        let xOffset = idParams.includes('l') ? -2 : 0;
        xOffset = idParams.includes('r') ? 2 : xOffset;
        let yOffset = idParams.includes('u') ? -2 : 0;
        yOffset = idParams.includes('d') ? 2 : yOffset;

        const iconPosition = sheetConfig.mapping[id]
          .map((position) => position * -sheetConfig.spriteSize + 'px')
          .join(' ');

        return (
          <div
            key={iconId}
            className="iconPiece"
            style={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              opacity,
              scale: `${scaleX} ${scaleY}`,
              backgroundImage: `url(${sheetConfig.source})`,
              backgroundSize: 100 * sheetConfig.numberOfColumns + '%',
              backgroundPosition: iconPosition,
              transform: `translate(${xOffset}px, ${yOffset}px)`,
              filter: 'drop-shadow(2px 2px 0 rgba(200,250,250,0.15))',
            }}
          ></div>
        );
      })}
    </div>
  );
};
